import moment from "moment";

const DATE_FORMATS = [
  moment.ISO_8601,
  "YYYY-MM-DD HH:mm:ss",
  "YYYY-MM-DD",
  "YYYY/MM/DD HH:mm:ss",
  "YYYY/MM/DD",
  "MM/DD/YYYY HH:mm:ss",
  "MM/DD/YYYY",
  "DD/MM/YYYY HH:mm:ss",
  "DD/MM/YYYY",
  "MM-DD-YYYY",
  "DD-MM-YYYY",
  "MMM DD, YYYY",
  "MMMM DD, YYYY",
];

const DATE_HEADER = /\bDATE\b|\bENCODED ON\b|\b(?:ADDED|CREATED|UPDATED|COMPLETED|ISSUED) ON\b/i;

export const isDateColumnHeader = (header) => {
  const label = typeof header === "string" ? header : header?.label;
  return typeof label === "string" && DATE_HEADER.test(label);
};

export const dateTimestamp = (value) => {
  if (value === null || value === undefined || value === "" || value === "0000-00-00") {
    return null;
  }

  if (value instanceof Date) {
    const timestamp = value.getTime();
    return Number.isNaN(timestamp) ? null : timestamp;
  }

  const parsed = moment(value, DATE_FORMATS, true);
  return parsed.isValid() ? parsed.valueOf() : null;
};

export const compareDateValues = (left, right) => {
  const leftTimestamp = dateTimestamp(left);
  const rightTimestamp = dateTimestamp(right);

  if (leftTimestamp === null && rightTimestamp === null) return 0;
  if (leftTimestamp === null) return 1;
  if (rightTimestamp === null) return -1;

  return leftTimestamp - rightTimestamp;
};

export const createDateSort = (selector) => (leftRow, rightRow) =>
  compareDateValues(selector(leftRow), selector(rightRow));
